export default "__VITE_ASSET__CbMELvPY__"